var OdiratingHeaderView = Backbone.View.extend({
    selectors: {
        advantadgeModal: '.advantadge_modal',
    },
    initialize: function(options) {
        this.template = options.template;
        this.tests = options.tests;
        this.numAdvantagesShown = options.numAdvantagesShown;
        this.translations = options.translations;
        this.templateData = this.createOdiRatingTemplateData(options.item);
    },
    render: function() {
        this.$el.html(this.template(this.templateData));
        this.bindAdvantadgeModal();
        return this;
    },
    bindAdvantadgeModal: function() {
        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$el.find(this.selectors.advantadgeModal), {
            events: {
                tap: true,
            },
            googleAnalyticsOnOpen: {
                type: 'trackEvent',
                data: {
                    action: 'odi',
                    label: 'more_info_click',
                },
            },
            closeOthers: false,
            closeContainer: false,
        });
    },

    getAdvantadgeIcon: function(advantage) {
        var iconTextBefore = '<span class="odf-icon odf-text-lg odf-space-outer-right-s odf-icon-';
        var iconTextAfter = '"></span>';
        var iconAdvantadgeMatcher = {
            priceAdvantage: 'cash',
            directAdvantage: 'flight-right',
            durationAdvantage: 'time',
            baggageAdvantage: 'checkin-baggage',
            weekendAdvantage: 'calendar',
            airportsAdvantage: 'plane-going',
        };

        return iconTextBefore + iconAdvantadgeMatcher[advantage] + iconTextAfter;
    },
    createOdiratingAdvantadgeKeys: function(odiRatingAdvantages, odiRatingPluralKeysIndex) {
        var translations = this.translations;
        return Odigeo._.map(odiRatingAdvantages, Odigeo._.bind(function(advantage) {
            return this.getAdvantadgeIcon(advantage) + Odigeo.Utils.pluralizeAll(translations[advantage], odiRatingPluralKeysIndex);
        }, this));
    },
    createOdiRatingTemplateData: function(item) {
        var hasCharterDisclaimer = item.isFlightCharter && (item.isDistinctDates !== 'false' || item.isDistinctTimes !== 'false');
        var odiRatingPluralKeysIndex = item.numberOfSegments > 1 ? 1 : 0;
        var benefitsShown = !this.tests.sortingTabsEnabled && !Odigeo.Utils.isRequestApp('dp');
        var odiRatingAdvantages;
        var odiRatingAdvantageTexts;
        if (benefitsShown) {
            odiRatingAdvantages = Odigeo._.filter(Odigeo._.map(item.odiRating.advantages, function(value, key) {
                return value && key;
            }));
            odiRatingAdvantages = odiRatingAdvantages.slice(0, this.numAdvantagesShown);
            odiRatingAdvantageTexts = this.createOdiratingAdvantadgeKeys(odiRatingAdvantages, odiRatingPluralKeysIndex);
        }
        return {
            translations: this.translations,
            hasCharterDisclaimer: hasCharterDisclaimer,
            odiRatingPluralKeysIndex: odiRatingPluralKeysIndex,
            odiRatingAdvantages: odiRatingAdvantages,
            odiRatingAdvantageTexts: odiRatingAdvantageTexts,
            benefitsShown: benefitsShown,
        };
    },
});

module.exports = OdiratingHeaderView;
